import { durationParamsToMs } from './durationParams.js'
import { DurationLike, UnixDuration } from './UnixDuration.js'

export function durationLikeToMs(value: DurationLike): bigint {
  if (UnixDuration.isInstance(value)) {
    return value.toMilliseconds()
  }
  return durationParamsToMs(value)
}
